import { useInfiniteQuery } from '@tanstack/react-query';
import { ClientService } from '@/services/clientService';
import { queryKeys } from '@/hooks/queries/queryKeys';

const CLIENTS_PAGE_SIZE = 50;

export function useClientsInfiniteQuery(enabled: boolean) {
    const query = useInfiniteQuery({
        queryKey: queryKeys.clients(),
        queryFn: ({ pageParam }) => ClientService.getClients(pageParam, CLIENTS_PAGE_SIZE),
        initialPageParam: 1,
        getNextPageParam: (lastPage, allPages) => {
            if (lastPage.clients.length < CLIENTS_PAGE_SIZE) return undefined;
            return allPages.length + 1;
        },
        enabled,
    });

    const clients = query.data?.pages.flatMap((p) => p.clients) ?? [];
    const loadMoreClients = async (): Promise<boolean> => {
        if (!query.hasNextPage) return false;
        await query.fetchNextPage();
        return (query.data?.pages.flatMap((p) => p.clients).length ?? 0) > clients.length;
    };

    return {
        clients,
        isLoading: query.isLoading,
        isFetching: query.isFetching,
        loadMoreClients,
        hasNextPage: query.hasNextPage,
        refetch: query.refetch,
        error: query.error,
    };
}
